import { useTranslation } from "react-i18next";
import { motion, Variants } from "framer-motion";

import styles from "./styles.module.css";
import CustomButton from "src/components/customButton/CustomButton";
import HeroImg from "src/assets/images/home/hero.webp";

import { isRTL } from "src/utils/global";
import { scrollToSection } from "src/utils/scroll";
import { Element } from "react-scroll";

const HeroSection: React.FC = () => {
    const { t } = useTranslation("home");

    const fadeUp: Variants = {
        hidden: { opacity: 0, y: 40 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.2,
                duration: 0.8,
                ease: "easeOut",
            },
        }),
    };

    return (
        <Element
            name="hero"
            className={`${styles.hero__con} ${styles.desktopFlip} ${isRTL() ? styles.rtl : ""
                }`}
            style={{ ["--hero-image" as any]: `url(${HeroImg})` }}
        >
            <div className={styles.content}>
                <motion.h2
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={0}
                >
                    {t("hero.tagline")}
                </motion.h2>

                <motion.p
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={1}
                >
                    {t("hero.description")}
                </motion.p>

                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                >
                    <CustomButton
                        text={t("hero.explore")}
                        theme="outlined"
                        className={styles.btn}
                        onClick={() => scrollToSection("aboutUs")}
                    />
                </motion.div>
            </div>
        </Element>
    );
};

export default HeroSection;
